<template>
  <div>
    <!-- 头部 -->
    <top :isNav="false" ></top>
    <!-- 页面头部 -->
   <header class="header-jp"></header>
    <!-- 主内容区域 -->
    <main class="main-content">
      <div class="container buttons-group top-buttons">
        <a
          class="button"
          href="https://reg.reed-sinopharm.com/pc/#/login?id=d53d1235522243d7b93a68f807e291cb&channelUuid=a04d67b16100422bb1e9db3e81555964"
          target="_blank"
        >
          <p>来場者として登録 <br />するにはこちらをクリック</p>
          <img src="../assets/japanese/icon-youjiantou.png" alt="" class="iconfont" />
        </a>
        <a
          class="button"
          href="https://www.apichina.com.cn/#/newsdetails?id=521"
          target="_blank"
        >
          <p>出展者登録</p>
          <img src="../assets/japanese/icon-youjiantou.png" alt="" class="iconfont" />
        </a>
      </div>

      <div class="qr-code">
        <img src="../assets/japanese/qr-code.jpg" alt="QR Code" />
        <p>
          下記のQRコードをスキャンして<br />
          LinkedInページをフォローください。
        </p>
      </div>

      <div class="container market-overview">
        <div class="section-header">
          <div class="icon-group"></div>
          <h2>中国の医薬品市場の概要 / 業界情報</h2>
        </div>
        <div class="cards-grid">
          <div class="card">
            <img src="../assets/japanese/icon1.png" class="card-logo" />
            <div class="card-content">
              <h3>医薬品市場</h3>
              <p>·2019年の2363億ドルから2021年の2643億ドルへ増加</p>
              <p>·2019年から2021年の年間増加率6.4％</p>
            </div>
          </div>
          <div class="card">
            <img src="../assets/japanese/icon2.png" class="card-logo" />
            <div class="card-content">
              <h3>APIの輸入</h3>
              <p>·2022年には前年比23.46%増となる77億1,300万ドルとなる</p>
            </div>
          </div>
          <div class="card">
            <img src="../assets/japanese/icon3.png" class="card-logo" />
            <div class="card-content">
              <h3>CMO市場</h3>
              <p>·2024年に105億ドルに達すると予想されている</p>
            </div>
          </div>
          <div class="card">
            <img src="../assets/japanese/icon4.png" class="card-logo" />
            <div class="card-content">
              <h3>バイオ医薬品市場</h3>
              <p>·2025年に1,241億5千万ドルに達すると予想されている</p>
              <p>·16,425社のバイオ医薬品企業</p>
            </div>
          </div>
          <div class="card">
            <img src="../assets/japanese/icon5.png" class="card-logo" />
            <div class="card-content">
              <h3>医薬品用包装市場</h3>
              <p>·2022年には前年比16%増となる222億6,500万ドルとなる</p>
            </div>
          </div>
          <div class="card">
            <img src="../assets/japanese/icon6.png" class="card-logo" />
            <div class="card-content">
              <h3>医薬品用添加剤市場</h3>
              <p>·2020年、470社の製造企業</p>
              <p>·2021年、92億ドルの規模</p>
            </div>
          </div>
          <div class="card">
            <img src="../assets/japanese/icon7.png" class="card-logo" />
            <div class="card-content">
              <h3>医薬品用設備市場</h3>
              <p>·2020年には世界全体の22.6%を占める80億3,800万ドルとなる</p>
              <p>·2025年に130億7,200万ドルに達すると予想されている</p>
            </div>
          </div>
          <div class="card">
            <img src="../assets/japanese/icon8.png" class="card-logo" />
            <div class="card-content">
              <h3>栄養補助/機能性薬品市場</h3>
              <p>·2020年、8,693社の製造企業</p>
              <p>·2022年、246億5,100万ドル</p>
            </div>
          </div>
        </div>
      </div>

      <div class="container about-exhibition">
        <div class="section-header">
          <div class="icon-group"></div>
          <h2>展示会について</h2>
        </div>
        <p>
          API
          Chinaは、中国の5000以上のAPI、化学医薬品、バイオ医薬品、製剤加工TCMメーカー、CRO/CMO/CDMOから6万人以上の製薬専門家を集めた展示会であり、国際的な製薬専門家にとって理想的なビジネスプラットフォームとなっています。
        </p>
        <p>
          「中国製薬産業サイクルのグランドプラットフォーム、グローバル製薬産業チェーンの揺籃」をテーマとしており、原料、受託サービス、バイオ医薬品、技術、包装、機械などの企業が1200社以上毎回出展しています。
        </p>
        <p>
          当展示会は約5,000社の中国製薬企業に最も好まれつつあるプラットフォームとなっており、展示会と調達に100強中の企業の97社が出展。
        </p>
      </div>

      <div class="container scale-exhibition">
        <div class="section-header">
          <div class="icon-group"></div>
          <h2>展示会規模</h2>
        </div>
        <p>6万平米にわたる合計展示スペース</p>

        <ul class="scale-list">
          <li>·出展者数：1200以上</li>
          <li>·新規出展社数：200以上</li>
          <li>·翌年も出展を継続する企業数：92.21 %</li>
        </ul>

        <ul class="scale-list">
          <li>·講演の話題：100以上</li>
          <li>·来場者数：世界各国から3万人以上</li>
          <li>·翌年の来場予定者率：96%</li>
        </ul>
      </div>

      <div class="container meeting">
        <p class="meeting-title">会議</p>
        <p class="meeting-content">
          中国政府機関やその他の組織から100人以上の専門家、中国100強の製薬企業の研究開発·生産担当幹部を招き、それぞれの見解、洞察、データ、事例およびソリューションを共有します。
        </p>
      </div>

      <div class="container highlights">
        <div class="section-left">
          <div class="section-header">
            <div class="icon-group"></div>
            <h2>見どころ</h2>
          </div>
          <ul>
            <li>・中国製薬エンジニアリング会議</li>
            <li>・中国医薬品産業市場情報会議</li>
            <li>・中国API市場報告会</li>
            <li>・中国医薬品産業製造及び販売説明会</li>
          </ul>
        </div>
        <div class="section-center">
          <img src="../assets/japanese/meeting.png" alt="Highlights Image" />
        </div>

        <div class="section-right">
          <div class="section-header">
            <div class="icon-group"></div>
            <h2>後援団体</h2>
          </div>
          <ul class="sponsor-list">
            <li>中国医薬工業協会(CPIA)</li>
            <li>中国医薬包装協会(CNPPA)</li>
          </ul>
        </div>
      </div>

      <div class="container visitor-stats">
        <div class="title">
          中国国内製薬業界100強のうち97社が参加しています。
        </div>

        <div class="stats-grid">
          <div class="stat-item">
            <div class="section-header">
              <div class="icon-group"></div>
              <h2>業種別来場者率</h2>
            </div>
            <img src="../assets/japanese/bar1.jpg" alt="Chart 1" class="bar" />
          </div>
          <div class="stat-item">
            <div class="section-header">
              <div class="icon-group"></div>
              <h2>職責別来場者率</h2>
            </div>
            <img src="../assets/japanese/bar2.jpg" alt="Chart 2" class="bar" />
          </div>
          <div class="stat-item">
            <div class="section-header">
              <div class="icon-group"></div>
              <h2>調達決定権(役割)別の来場者比率</h2>
            </div>
            <img src="../assets/japanese/pie1.jpg" alt="Chart 3" class="pie" />
          </div>
          <div class="stat-item">
            <div class="section-header">
              <div class="icon-group"></div>
              <h2>興味別の来場者比率</h2>
            </div>
            <img src="../assets/japanese/pie2.jpg" alt="Chart 4" class="pie" />
          </div>
        </div>

        <div class="satisfaction">
          <div class="satisfaction-text">
            <p>来場者の満足度</p>
            <p>
              来場者のうち92％が第92回API
              Chinaに完全に満足または多いに満足したと回答しており、第91回API
              Chinaよりも更に増加しています。
            </p>
          </div>
          <img
            src="../assets/japanese/satisfaction-img.jpg"
            alt=""
            class="satisfaction-img"
          />
        </div>
      </div>

      <div class="container medicine-info">
        <div class="title-f">見どころ</div>
        <div class="medicine-cards">
          <div class="card">
            <h3>医薬品原料</h3>
            <ul>
              <li>・原薬（API）</li>
              <li>・バイオ医薬</li>
            </ul>
            <ul>
              <li>・ファインケミカル</li>
              <li>・CRO/CMO/CDMO</li>
            </ul>
            <ul>
              <li>・中間体</li>
              <li>・天然抽出物</li>
            </ul>
            <ul>
              <li>・栄養（機能性）食品用原料</li>
              <li>・動物用医薬品原薬</li>
            </ul>
          </div>
          <div class="card">
            <h3>医薬品添加剤</h3>
            <ul>
              <li class="li-left">・酸性化／アルカリ化剤</li>
              <li>・吸着剤</li>
            </ul>
            <ul>
              <li class="li-left">・結着補強剤</li>
              <li>・コーティング剤</li>
            </ul>
            <ul>
              <li class="li-left">・シクロデキストリン</li>
              <li>・希釈剤または充填剤</li>
            </ul>
            <ul>
              <li class="li-left">・分解剤</li>
              <li>・香料／甘味料／着色料</li>
            </ul>
          </div>
          <div class="card">
            <h3>医薬品用包装</h3>
            <ul>
              <li>・アルミ箔</li>
              <li>・キャップ / ブチル製ゴム栓</li>
            </ul>
            <ul>
              <li>・カプセル / ゼラチン</li>
              <li>・薬物配送システム</li>
            </ul>
            <ul>
              <li>・医薬用プラスチック</li>
              <li>・チューブ</li>
            </ul>
            <ul>
              <li>・医薬用ガラス</li>
              <li>・印刷</li>
            </ul>
          </div>
          <div class="card">
            <h3>医薬用機械設備</h3>
            <ul>
              <li class="li-left">・API用装置</li>
              <li class="li-left">・自動化装置</li>
            </ul>
            <ul>
              <li class="li-left">・バイオ医薬品用装置</li>
              <li>・EP＆クリーン技術</li>
            </ul>
            <ul>
              <li class="li-left">・実験室/試験装置</li>
              <li>・調整装置</li>
            </ul>
            <ul>
              <li class="li-left">・医薬用制水処理装置</li>
              <li>・製薬エンジニアリング設計・施工</li>
            </ul>
          </div>
        </div>
        <div class="title-s">現時点における海外からの出展者</div>
        <img src="../assets/japanese/all-logo.jpg" alt="logo" class="medicine-all-logo" />
        <div class="title-t">フィードバック</div>
        <div class="medicine-content">
          <div class="title">
            修正薬業集団（Xiuzheng Pharmacy
            Group）調達供給管理センター　Tingting Liu
          </div>
          <p class="text">
            API
            Chinaは弊社にとって長い間既存顧客とのミーティングや、新規サプライヤーを探すための重要なプラットフォームになっています。このイベントにはほぼ毎年参加しており、近年は積極的にビジネスマッチングに参加することで、ターゲットとなる製品の調達や新たな仲間作りができています。今後もAPI
            Chinaが更に良くなることを願っています。来年のAPI China in
            広州で新旧の知人と集まれることを楽しみにしています。
          </p>
        </div>
        <div class="medicine-content">
          <div class="title">
            四川匯麗工業株式会社（Sichuan Hui Li Industry Co., Ltd.）
          </div>
          <p>
            中国で最も規模が大きく権威と影響力を持つ医薬品用包装材イベントとなるPHARMPACKは匯麗工業にとって重要なパートナーとなっています。現在弊社は中国最大級の包装専門企業の一つとして、充実した支援施設、多様な製品ラインナップ、先進的な技術や製造設備、最大級の生産規模および体系的な品質管理システムを擁する企業として著しい成長を遂げています。
          </p>
        </div>
        <div class="medicine-content">
          <div class="title">
            Hainan PolyPharm Company Limited（海南普利制薬株式会社）
          </div>
          <p>
            今年のAPI
            Chinaには積極的に参加しました。本イベントは、当社が中国国内・海外市場を拡大する重要な機会を提供し、顧客のニーズや市場動向を把握する場となっています。当社のグローバル市場における主力製品であるアジスロマイシン注射剤をはじめとする抗パンデミック製品は、新型コロナウイルスの爆発的な流行期間中、マーケットにおいて著しい実績を残しました。弊社にこのプラットフォームを提供してくれているAPI
            Chinaに感謝するとともに、ますます発展していけるよう願っています。
          </p>
        </div>
        <div class="medicine-content">
          <div class="title">Beijing Jingliang Biotech Group Co., Ltd.</div>
          <p class="text-s">
            医薬品用添加材業界は、政策や規制の変更により急速な普及と市場規模の拡大を遂げており、これらは弊社にも歴史的なチャンスをもたらしています。当社の子会社であるQulu医薬材料は、毎年API
            Chinaで高品質な医薬品用添加剤を展示しており、優れた成果を上げています。API
            Chinaの今後のご発展を心よりお祈り申し上げます。
          </p>
        </div>
        <div class="medicine-content">
          <div class="title">
            上海工糖化工有限公司(Shanghai GongTang Chemical Engineering Co.,
            Ltd.)
          </div>
          <p class="text">
            この医薬品機器展示会は、出展企業が製造企業の品質担当者、調達担当者、および経営幹部と直接対話する機会を提供してくれました。弊社は多くの企業と暫定的な調達合意書を締結、近日中に現地視察を実施する予定です。
          </p>
        </div>

        <div class="title-f">グループについて</div>
        <div class="medicine-logo">
          <img src="../assets/japanese/company-logo1.jpg" alt="国药集团" />
          <img src="../assets/japanese/company-logo2.jpg" alt="励展博览集团" />
        </div>

        <div class="medicine-sinopharm">
          <img src="../assets/japanese/company-logo3.jpg" alt="国药励展" />
          <div class="info">
            <p>
              国薬励展（リード・シノファーム・エグジビションズ　Reed Sinopharm
              Exhibitions）株式会社は、中国において健康、美容、ウェルネス、教育分野に特化したイベント企画・運営会社として、最も著名な企業のひとつです。同社は、中国最大の医療・ヘルスケア企業グループであるシノファーム（中国国家医薬集団　Sinopharm）と、世界有数のイベント企画会社であるRX
              Globalとの合弁企業です。
            </p>
            <p>
              国薬励展は、高く評価されている38のイベントを運営、約21,000社の国内・海外出展企業を招き、1,200件を超えるカンファレンスと学術セミナーを開催しています。弊社のイベントは、合計1,650,000平方メートルの展示スペースを擁し、毎年150以上の国・地域から86万人を超える業界に関係する来場者を迎えています。
            </p>

            <p>
              国際的なイベントを通じて、顧客のビジネス構築、新しいチャンスの模索、主要な市場にアクセスするための革新的なソリューションを提供しています。
            </p>
          </div>
        </div>

        <img
          src="../assets/japanese/world-map.jpg"
          alt="world-map"
          class="medicine-world-map"
        />

        <div class="title-m">API China 国際·グループについて</div>
        <div class="medicine-word">
          <div class="card">
            <h3>ROW(世界のその他の地域) <br />国際販売部門</h3>
            <h3></h3>
            <p>Mr. Evan Wang</p>
            <p>電話：+86 10-8455-6692</p>
            <p>E-mail: ye.wang@reedsinopharm.com</p>
          </div>
          <div class="card">
            <h3>ROW(世界のその他の地域) <br />国際マーケティング部門</h3>
            <p>Ms. Jasmine Wang</p>
            <p>電話:+86 10 8455 6520</p>
            <p>E-mail: zheng.wang@reedsinopharm.com</p>
          </div>

          <div class="card">
            <h3>
              韓国 <br />リード·エグジビションズ
              <br />国際販売グループ国際販売部門
            </h3>
            <p>Mr. Kyong Ho Lee</p>
            <p>Tel:+82 10 5499 5833</p>
            <p>E-mail: Kyongho.lee@rxglobal.com</p>
          </div>
          <div class="card">
            <h3>日本 <br />RX Japan Ltd. <br />ISG</h3>
            <p>Ms. Natsumi Inoue</p>
            <p>電話:+81 80 3357 2546</p>
            <p>E-mail:natsumi.inoue@rxglobal.com</p>
          </div>
          <div class="card">
            <h3>
              インド <br />
              API、原材料、添加剤担当
            </h3>
            <p>Ms. Sapna Kritane</p>
            <p>Tel:+91 9987022774</p>
            <p>E-mail:sapna.kirtane@rxglobal.corn</p>
          </div>
          <div class="card">
            <h3>インド <br />包装、設備担当</h3>
            <p>Mr. Aarjav Shah</p>
            <p>Tel:+91 9879616665</p>
            <p>E-mail: aaijav@pharmatechnologyindex.com</p>
          </div>
        </div>
      </div>
    </main>

    <!-- 页面底部 -->
    <footer class="footer">
      <div class="container buttons-group">
        <a
          class="button"
          href="https://reg.reed-sinopharm.com/pc/#/login?id=d53d1235522243d7b93a68f807e291cb&channelUuid=a04d67b16100422bb1e9db3e81555964"
          target="_blank"
        >
          <p>来場者として登録 <br />するにはこちらをクリック</p>
          <img src="../assets/japanese/icon-youjiantou.png" alt="" class="iconfont" />
        </a>
        <a
          class="button"
          href="https://www.apichina.com.cn/#/newsdetails?id=521"
          target="_blank"
        >
          <p>出展者登録</p>
          <img src="../assets/japanese/icon-youjiantou.png" alt="" class="iconfont" />
        </a>
      </div>
    </footer>
  </div>
</template>

<script>
import top from "@/components/top.vue";
export default {
  // 配置title和meta数据
  metaInfo() {
    return {
      title: this.metaData.title,
      meta: [
        {
          name: "description",
          content: this.metaData.desc,
        },
        {
          name: "keywords",
          content: this.metaData.keywords,
        },
      ],
    };
  },
  components: {
    top,
  },
  data() {
    return {
      langSet: "",
    };
  },
  created() {},
  activated() {},
  mounted() {
    this.langSet = this.$language;
    this.metaData = JSON.parse(localStorage.getItem("metaData"));
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}
ul,
ol {
  list-style: none;
}
a {
  text-decoration: none;
  color: inherit;
  outline: none;
}
body {
  font-family: STSongti-SC, STSongti-SC;
  color: #333;
  line-height: 1.6;
}
h1,
h2,
h3 {
  color: #333;
  line-height: 1.2;
}
img {
  max-width: 100%;
  height: auto;
  display: block;
}
.container {
  width: 90%;
  max-width: 930px;
  margin: 0 auto;
}
.header-jp {
  height: 448px;
  background-image: url("../assets/japanese/banner.jpg");
  background-size: cover;
  background-position: 46%;
  background-repeat: no-repeat;
}
.header-jp img {
  object-fit: cover;
  height: 100%;
}
.main-content {
  position: relative;
}
.qr-code {
  position: fixed;
  top: 35%;
  right: 2%;
  z-index: 999;
  width: 220px;
  background: linear-gradient(133deg, #13B2C7 0%, #083F96 100%);
  border-radius: 15px;
  padding: 12px 12px 10px;
  font-weight: bold;
  color: #FFFFFF;
}
.qr-code p {
  margin-top: 10px;
  font-size: 0.625rem;
}
.qr-code img {
  max-width: 100%;
  height: auto;
}
/* Section Header */
.section-header {
  display: flex;
  align-items: center;
  margin-top: 30px;
  margin-bottom: 20px;
}
.section-header h2 {
  font-size: 1.5rem;
  font-weight: bold;
  color: #3c2d6f;
}
.section-header .icon-group {
  position: relative;
  width: 14px;
  height: 14px;
  background: #3c2d6f;
  border-radius: 50%;
  margin-right: 8px;
  flex-shrink: 0;
}
.section-header .icon-group::before {
  content: "";
  display: inline-block;
  width: 8px;
  height: 8px;
  background: #3c2d6f;
  opacity: 0.4;
  position: absolute;
  left: 9px;
  top: 3px;
  border-radius: 50%;
}
.cards-grid {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 20px;
  margin-top: 10px;
}
.cards-grid .card {
  width: 100%;
  max-width: 455px;
  height: 132px;
  background: #f2f0f7;
  border-radius: 80px 15px 80px 15px;
  display: flex;
  padding-top: 20px;
  position: relative;
}
.cards-grid .card .card-logo {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  flex-shrink: 0;
  margin-right: 15px;
  position: absolute;
  top: 0;
  left: 0;
}
.cards-grid .card .card-content {
  padding-left: 75px;
  padding-right: 20px;
  flex: 1;
}
.cards-grid .card .card-content h3 {
  font-size: 1.1rem;
  color: #000000;
  margin: 0 0 10px 0;
}
.cards-grid .card .card-content p {
  line-height: 1.4;
  font-weight: bold;
  font-size: 0.9rem;
  color: #000000;
}
.about-exhibition p,
.scale-exhibition p,
.about-exhibition li,
.scale-exhibition li {
  font-weight: bold;
  font-size: 1rem;
  color: #000000;
  line-height: 1.5;
}
.scale-exhibition .scale-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.meeting {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin-top: 30px;
  background: linear-gradient(180deg, rgba(129, 97, 175, 0.38) 0%, #463579 29%, #3c2d6f 59%, #3f2e71 79%, rgba(74, 50, 119, 0.38) 100%);
  padding: 20px;
  font-weight: bold;
  font-size: 1rem;
  color: #ffffff;
  line-height: 1.5;
}
.meeting .meeting-title {
  width: 120px;
  margin-right: 0;
  margin-bottom: 15px;
  font-size: 1.5rem;
  color: #ffffff;
  line-height: 1.2;
}
.highlights {
  display: flex;
  flex-direction: column;
  font-size: 1rem;
  color: #000000;
  line-height: 1.75;
}
.highlights .section-center,
.highlights .section-right {
  width: 100%;
}
.highlights .section-center {
  margin-top: 0;
}
.highlights .section-right .sponsor-list {
  background: #eeeeee;
  border-radius: 8px;
  padding: 30px 26px;
}
.visitor-stats {
  margin-top: 50px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.visitor-stats .title {
  width: 100%;
  height: auto;
  padding: 15px;
  background: #3c2d6f;
  border-radius: 30px;
  font-weight: bold;
  font-size: 1.5rem;
  color: #ffffff;
  line-height: 1.2;
  text-align: center;
}
.visitor-stats .stats-grid {
  display: flex;
  flex-direction: column;
  gap: 0px 86px;
  width: 100%;
}
.visitor-stats .stats-grid .stat-item {
  width: 100%;
}
.visitor-stats .stats-grid .stat-item .bar,
.visitor-stats .stats-grid .stat-item .pie {
  width: 100%;
}
.visitor-stats .stats-grid .stat-item:nth-child(4) .pie {
  padding-left: 10px;
  padding-right: 22px;
}
.visitor-stats .satisfaction {
  width: 100%;
}
.visitor-stats .satisfaction .satisfaction-text {
  display: flex;
  flex-direction: column;
  text-align: center;
  padding: 20px;
  margin-top: 33px;
  background: rgba(73, 51, 122, 0.15);
  border-radius: 15px 15px 0px 0px;
}
.visitor-stats .satisfaction .satisfaction-text p:nth-child(1) {
  font-weight: bold;
  font-size: 1.25rem;
  color: #000000;
  width: 100%;
  margin-right: 0;
  margin-bottom: 15px;
}
.visitor-stats .satisfaction .satisfaction-text p:nth-child(2) {
  font-weight: bold;
  font-size: 1rem;
  color: #000000;
}
.visitor-stats .satisfaction .satisfaction-img {
  max-height: 200px;
  border: 1px solid #d9d9d9;
  border-top: none;
  border-radius: 0 0 15px 15px;
  width: 100%;
  object-fit: cover;
}
.medicine-info {
  display: flex;
  flex-direction: column;
}
.medicine-info .title-f,
.medicine-info .title-s,
.medicine-info .title-t,
.medicine-info .title-f,
.medicine-info .title-m {
  padding: 11px 37px;
  margin: 28px auto 18px;
  background: #3c2d6f;
  border-radius: 17px;
  font-weight: bold;
  font-size: 1rem;
  color: #ffffff;
  max-width: 138px;
  text-align: center;
}
.medicine-info .title-s {
  width: 100%;
  max-width: 608px;
  text-align: center;
}
.medicine-info .title-t {
  width: 100%;
  max-width: 244px;
}
.medicine-info .title-f {
  width: 100%;
  max-width: 348px;
}
.medicine-info .title-m {
  width: 100%;
  max-width: 580px;
}
.medicine-info .medicine-cards {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
.medicine-info .medicine-cards .card {
  width: 100%;
  max-width: 455px;
  background: #f2f0f7;
  border-radius: 15px;
  padding: 20px 30px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
}
.medicine-info .medicine-cards .card:nth-child(2n) {
  margin-right: auto;
}
.medicine-info .medicine-cards .card h3 {
  font-weight: bold;
  font-size: 18px;
  color: #000000;
  margin-bottom: 10px;
}
.medicine-info .medicine-cards .card ul {
  display: flex;
}
.medicine-info .medicine-cards .card ul li {
  width: 60%;
  font-size: 14px;
  color: #000000;
  line-height: 21px;
  margin-bottom: 5px;
}
.medicine-info .medicine-cards .card ul .li-left {
  width: 45%;
}
.medicine-info .medicine-all-logo {
  width: 100%;
  max-width: 930px;
  max-height: 508px;
  margin-left: auto;
  margin-right: auto;
}
.medicine-info .medicine-content {
  width: 100%;
  height: auto;
  background: #f2f0f7;
  border-radius: 25px 15px 15px 15px;
  position: relative;
  margin-bottom: 20px;
}
.medicine-info .medicine-content .title {
  position: absolute;
  left: 0;
  padding: 10px 20px;
  background: linear-gradient(180deg, #6f59a8 0%, #3c2d6f 100%);
  border-radius: 25px 0px 25px 0px;
  color: #ffffff;
}
.medicine-info .medicine-content p {
  padding: 62px 30px 30px 30px;
  color: #000000;
  line-height: 28px;
}
.medicine-info .medicine-logo {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  margin-bottom: 50px;
  gap: 20px;
}
.medicine-info .medicine-logo img {
  width: 100%;
  max-width: 318px;
  height: 93px;
}
.medicine-info .medicine-sinopharm {
  display: flex;
  flex-direction: row;
  padding-bottom: 40px;
  border-bottom: 2px solid #000000;
}
.medicine-info .medicine-sinopharm img {
  min-width: 220px;
  height: 220px;
  background: #ffffff;
  margin-right: 20px;
  margin-bottom: 20px;
  align-self: center;
}
.medicine-info .medicine-sinopharm .info {
  flex: 1;
  font-weight: bold;
  color: #000000;
  line-height: 1.25rem;
}
.medicine-info .medicine-world-map {
  margin-top: 30px;
  width: 100%;
  max-width: 930px;
  max-height: 453px;
  margin-left: auto;
  margin-right: auto;
}
.medicine-info .medicine-word {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin-bottom: 250px;
}
.medicine-info .medicine-word .card {
  width: 100%;
  max-width: 296px;
  height: 214px;
  background: #f2f0f7;
  border-radius: 15px;
  padding: 20px 0px 20px 20px;
  color: #000000;
  font-weight: bold;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 20px;
}
.medicine-info .medicine-word .card:nth-child(3n) {
  margin-right: auto;
}
.medicine-info .medicine-word .card h3 {
  font-size: 18px;
  line-height: 25px;
  margin-bottom: 15px;
}
.medicine-info .medicine-word .card p {
  font-size: 12px;
  line-height: 28px;
}
/* Footer */
.footer {
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 150px;
  background: #b3b3b3;
}
.buttons-group {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #fff;
  flex-direction: column;
  gap: 20px;
  a{
    color: #fff;
  }
}
.buttons-group .button {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  max-width: 308px;
  height: 88px;
  background: linear-gradient(180deg, #6f59a8 0%, #3c2d6f 100%);
  box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.25);
  border-radius: 25px;
  padding: 20px;
}
.buttons-group .button:nth-child(1) {
  margin-right: 0;
}
.buttons-group .button .iconfont {
  width: 20px;
  height: 20px;
}
/* 大屏设备 (例如，宽度大于或等于 1200px) - 适配1920px设计稿 */
@media (min-width: 1200px) {
  .container {
    max-width: 930px;
  }
  .header {
    height: 448px;
  }
  .cards-grid .card {
    width: 455px;
    margin-left: 0;
    margin-right: 0;
  }
  .scale-exhibition .scale-list {
    flex-direction: row;
    justify-content: space-between;
  }
  .scale-exhibition .scale-list li {
    flex: 1;
    width: 33.3%;
  }
  .meeting {
    flex-direction: row;
    text-align: left;
    padding: 0 30px;
    height: 100px;
    border-radius: 0;
  }
  .meeting .meeting-title {
    margin-bottom: 0;
    margin-right: 50px;
    font-size: 1.5rem;
  }
  .highlights {
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
  }
  .highlights .section-left {
    width: 30%;
  }
  .highlights .section-center {
    width: 30%;
    margin-top: 30px;
  }
  .highlights .section-center img {
    width: 100%;
  }
  .highlights .section-right {
    width: 30%;
  }
  .visitor-stats .title {
    width: 748px;
    height: 60px;
    padding: 0;
    font-size: 1.75rem;
    line-height: 60px;
  }
  .visitor-stats .stats-grid {
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
  }
  .visitor-stats .stats-grid .stat-item {
    width: 422px;
  }
  .visitor-stats .satisfaction .satisfaction-text {
    flex-direction: row;
    align-items: center;
    text-align: left;
    height: 126px;
    padding: 0 30px;
  }
  .visitor-stats .satisfaction .satisfaction-text p:nth-child(1) {
    max-width: 175px;
    margin-bottom: 0;
    text-align: left;
  }
  .medicine-info .medicine-cards .card {
    width: 455px;
    margin-left: 0;
    margin-right: 20px;
  }
  .medicine-info .medicine-cards .card:nth-child(2n) {
    margin-right: 0;
  }
  .medicine-info .medicine-word .card {
    width: 296px;
    margin-left: 0;
    margin-right: 20px;
  }
  .medicine-info .medicine-word .card:nth-child(3n) {
    margin-right: 0;
  }
  .medicine-info .medicine-info .medicine-sinopharm {
    flex-direction: row !important;
  }
  .medicine-info .medicine-info .medicine-sinopharm img {
    margin-bottom: 0;
    margin-right: 20px;
  }
  .buttons-group {
    flex-direction: row;
    gap: 40px;
    padding: 0;
  }
  .buttons-group .button {
    width: 308px;
  }
  .top-buttons {
    padding-bottom: 20px;
    padding-top: 50px;
  }
}
/* 中等屏幕设备 (例如，宽度在 992px 到 1199px 之间) */
@media (min-width: 992px) and (max-width: 1199px) {
  .container {
    max-width: 930px;
  }
  .qr-code {
    width: 170px;
    right: 2%;
  }
  .buttons-group {
    flex-direction: row;
  }
  .buttons-group .button {
    width: 308px;
  }
  .buttons-group .button:nth-child(1) {
    margin-right: 40px;
  }
  .top-buttons {
    padding-bottom: 20px;
    padding-top: 50px;
  }
  .cards-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
    gap: 20px;
  }
  .scale-exhibition .scale-list {
    flex-direction: row;
  }
  .scale-exhibition .scale-list li {
    width: 33.3%;
  }
  .meeting {
    flex-direction: row;
    align-items: center;
    text-align: left;
  }
  .meeting .meeting-title {
    width: 120px;
    margin-right: 50px;
    margin-bottom: 0;
  }
  .visitor-stats .stats-grid {
    justify-content: space-between;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    gap: 0 50px;
  }
  .visitor-stats .stats-grid .stat-item {
    width: 47%;
  }
  .medicine-info .medicine-cards .card {
    width: 48%;
  }
  .medicine-sinopharm {
    flex-direction: row;
  }
  .highlights {
    flex-direction: row;
    justify-content: space-between;
  }
  .highlights .section-left,
  .highlights .section-right {
    width: 30%;
  }
  .highlights .section-center {
    width: 30%;
    margin: 30px 0px 0;
  }
  .highlights .section-center img {
    max-width: 100%;
    height: auto;
  }
}
/* 平板设备 (例如，宽度在 768px 到 991px 之间) */
@media (min-width: 768px) and (max-width: 991px) {
  body {
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
  }
  .container {
    max-width: 750px;
  }
  h2 {
    font-size: 1.75rem;
  }
  .header {
    height: 380px;
  }
  .qr-code {
    width: 140px;
    right: 2%;
  }
  .cards-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 20px;
  }
  .scale-exhibition .scale-list {
    flex-direction: row;
    justify-content: space-between;
    gap: 20px;
  }
  .scale-exhibition .scale-list li {
    flex: 1;
  }
  .meeting {
    flex-direction: row;
    text-align: left;
    padding: 0 30px;
    height: 100px;
    border-radius: 0;
  }
  .meeting .meeting-title {
    margin-bottom: 0;
    margin-right: 30px;
    font-size: 1.5rem;
    width: 120px;
  }
  .highlights {
    flex-direction: row;
  }
  .highlights .section-left,
  .highlights .section-right {
    width: 33.3%;
  }
  .highlights .section-center {
    width: 30%;
    margin: 60px 20px 0;
  }
  .highlights .section-center img {
    max-width: 100%;
    height: auto;
  }
  .visitor-stats .title {
    font-size: 1.75rem;
  }
  .visitor-stats .stats-grid {
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    gap: 0 26px;
  }
  .visitor-stats .stats-grid .stat-item {
    width: 48%;
  }
  .visitor-stats .stats-grid .stat-item:nth-child(4) .pie {
    margin-top: 50px;
  }
  .visitor-stats .satisfaction .satisfaction-text {
    flex-direction: row;
    align-items: center;
    text-align: left;
    height: 126px;
  }
  .visitor-stats .satisfaction .satisfaction-text p:nth-child(1) {
    width: 175px;
    margin-bottom: 0;
    margin-right: 30px;
  }
  .medicine-info .medicine-cards .card {
    width: 100%;
    max-width: none;
  }
  .medicine-info .medicine-cards .card ul li {
    width: 50% !important;
  }
  .buttons-group {
    flex-direction: row;
  }
  .top-buttons {
    padding-bottom: 20px;
    padding-top: 50px;
  }
}
/* 小屏幕设备 (例如，宽度小于 768px) */
@media (max-width: 767px) {
  body {
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
  }
  .container {
    width: 90%;
  }
  .header {
    height: 200px;
  }
  h1 {
    font-size: 1.5rem;
  }
  h2 {
    font-size: 1.25rem;
  }
  h3 {
    font-size: 1.1rem;
  }
  p,
  li,
  .about-exhibition p,
  .about-exhibition li,
  .scale-exhibition p,
  .scale-exhibition li,
  .meeting,
  .highlights,
  .medicine-info .medicine-word .card p,
  .medicine-info .medicine-sinopharm .info,
  .visitor-stats .satisfaction .satisfaction-text p:nth-child(2) {
    font-size: 0.875rem;
  }
  .qr-code {
    width: 120px;
    right: 2%;
  }
  .section-header h2 {
    font-size: 1.25rem;
  }
  .cards-grid .card {
    width: 100%;
    height: auto;
    padding: 15px;
  }
  .cards-grid .card .card-content h3 {
    font-size: 1rem;
  }
  .cards-grid .card .card-content p {
    font-size: 0.875rem;
  }
  .scale-exhibition .scale-list {
    flex-direction: column;
    gap: 10px;
    margin-top: 10px;
  }
  .meeting {
    flex-direction: column;
    text-align: center;
    padding: 20px;
    height: auto;
  }
  .meeting .meeting-title {
    margin-right: 0;
    margin-bottom: 15px;
    font-size: 1.25rem;
  }
  .highlights {
    flex-direction: column;
  }
  .highlights .section-left,
  .highlights .section-center,
  .highlights .section-right {
    width: 100%;
  }
  .highlights .section-center {
    display: flex;
    justify-content: center;
  }
  .highlights .section-center img {
    height: 200px;
  }
  .highlights .section-left {
    margin-bottom: 1.8rem;
  }
  .visitor-stats .title {
    font-size: 1.25rem;
    padding: 10px;
    height: auto;
    line-height: 1.4;
  }
  .visitor-stats .stats-grid {
    flex-direction: column;
  }
  .visitor-stats .stats-grid .stat-item {
    width: 100%;
  }
  .visitor-stats .satisfaction .satisfaction-text {
    flex-direction: column;
    height: auto;
    padding: 20px;
    text-align: center;
  }
  .visitor-stats .satisfaction .satisfaction-text p:nth-child(1) {
    width: 100%;
    margin-right: 0;
    margin-bottom: 15px;
    font-size: 1.1rem;
  }
  .visitor-stats .satisfaction .satisfaction-text p:nth-child(2) {
    font-size: 0.875rem;
  }
  .medicine-info .title-f,
  .medicine-info .title-s,
  .medicine-info .title-t,
  .medicine-info .title-f,
  .medicine-info .title-m {
    width: auto;
    font-size: 0.875rem;
    padding: 5px 20px;
    margin: 20px auto 15px;
  }
  .medicine-info .medicine-cards .card {
    width: 100%;
    height: auto;
    padding: 15px;
  }
  .medicine-info .medicine-cards .card h3 {
    font-size: 1rem;
    margin-bottom: 8px;
  }
  .medicine-info .medicine-cards .card ul li {
    width: 50% !important;
    font-size: 0.8rem;
    line-height: 1.5;
    margin-bottom: 3px;
  }
  .medicine-info .medicine-logo {
    flex-direction: column;
    align-items: center;
    margin-bottom: 1.25rem;
  }
  .medicine-info .medicine-logo img {
    height: 70px;
    object-fit: contain;
  }
  .medicine-info .medicine-content p {
    padding: 78px 30px 30px 30px;
    font-size: 0.875rem;
    line-height: 1.6;
  }
  .medicine-info .medicine-content .text-s {
    padding: 50px 30px 30px 30px;
  }
  .medicine-info .medicine-content .title {
    font-size: 0.875rem;
    padding: 8px 15px;
  }
  .medicine-info .medicine-word .card {
    height: auto;
    padding: 15px 10px 15px 15px;
  }
  .medicine-info .medicine-word .card h3 {
    font-size: 1rem;
    margin-bottom: 10px;
  }
  .medicine-info .medicine-word .card p {
    font-size: 0.75rem;
    line-height: 1.6;
  }
  .medicine-info .medicine-sinopharm {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
  .medicine-info .medicine-sinopharm img {
    margin: 0 auto 1.25rem;
    width: 140px;
    height: 140px;
    object-fit: contain;
  }
  .medicine-info .medicine-sinopharm .info {
    font-size: 0.875rem;
    line-height: 1.5;
  }
  .buttons-group .button {
    height: 4.375rem;
    padding: 0.9375rem;
    font-size: 0.875rem;
  }
  .top-buttons {
    padding-bottom: 1.25rem;
    padding-top: 3.125rem;
  }
  .footer {
    height: 200px;
  }
}

</style>